__turbopack_context__.v({
  "className": "barlow_condensed_983b4429-module__V4MaTq__className",
});
